import { IntlShape } from 'react-intl'
import classNames from 'classnames'
import type { Operation } from '..'

// Shared by the operations and partner operations tables
export function getPointsColumns(intl: IntlShape) {
   return [
      {
         header: () => <div>{intl.formatMessage({ id: 'operations.table.points.generated' })}</div>,
         accessorKey: 'pointsAccumulated',
         // size: 90,
         // minSize: 80,
         cell: ({ row }: { row: { original: Operation } }) => {
            const pointsAccumulated = row.original.pointsAccumulated
            const isPositive = pointsAccumulated != null && pointsAccumulated > 0
            const isRedemption = row.original.operationType === 'REDEMPTION'
            const showDash = pointsAccumulated == null || (isRedemption && pointsAccumulated === 0)
            return (
               <div className={classNames('text-center font-semibold', { 'text-green-600': isPositive })}>
                  {showDash ? '--' : isPositive ? `+${pointsAccumulated}` : pointsAccumulated}
               </div>
            )
         },
         enableSorting: true,
      },
      {
         header: () => <div>{intl.formatMessage({ id: 'operations.table.points.used' })}</div>,
         accessorKey: 'pointsRedeemed',
         // size: 90,
         // minSize: 80,
         cell: ({ row }: { row: { original: Operation } }) => {
            const pointsRedeemed = row.original.pointsRedeemed
            const isPositive = pointsRedeemed != null && pointsRedeemed > 0
            return (
               <div className={classNames('text-center font-semibold', { 'text-red-600': isPositive })}>
                  {pointsRedeemed == null ? '--' : isPositive ? `-${pointsRedeemed}` : pointsRedeemed}
               </div>
            )
         },
         enableSorting: true,
      },
      {
         header: () => <div>{intl.formatMessage({ id: 'operations.table.points.remaining' })}</div>,
         accessorKey: 'pointsRemaining',
         // size: 90,
         // minSize: 80,
         enableSorting: true,
         cell: ({ row }: { row: { original: Operation } }) => {
            const pointsRemaining = row.original.pointsRemaining
            const isRedemption = row.original.operationType === 'REDEMPTION'
            const showDash = pointsRemaining == null || (isRedemption && pointsRemaining === 0)
            return <div className="text-center font-semibold">{showDash ? '--' : pointsRemaining}</div>
         },
      },
      // Backend-built label ("Vencido <date> -N vencidos") colored by expirationColor:
      // RED = expired, ORANGE = expires within 45 days. Sorting stays on pointsExpirationDate.
      {
         header: () => <div>{intl.formatMessage({ id: 'operations.table.points.expiresOn' })}</div>,
         accessorKey: 'pointsExpirationDate',
         // size: 110,
         // minSize: 100,
         enableSorting: true,
         cell: ({ row }: { row: { original: Operation } }) => {
            const expirationColor = row.original.expirationColor
            return (
               <div
                  className={classNames('text-center', {
                     'text-red-600': expirationColor === 'RED',
                     'text-orange-600': expirationColor === 'ORANGE',
                  })}
               >
                  {row.original.expirationLabel || '--'}
               </div>
            )
         },
      },
   ]
}
